import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import store from './store';
import App from './pages/form-request-appointment.vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);

// init app
const el = document.querySelector('#form-request-appointment');
if (el) {
	new Vue({
		store,
		components: {
			app: App,
		},
	}).$mount('#form-request-appointment');
}
